<div class="titles-wrapper">
    <div class="title" *ngFor="let tab of tabs.toArray()" (click)="!tab.disabled && selectTab(tab)" [class.active]="tab.active"
        [class.disabled]="tab.disabled">
        {{ tab.name }}
    </div>
</div>

<div class="tab-wrapper">
    <ng-content></ng-content>
</div>
